<template>
  <transition name="fade" mode="out-in">
    <div class="page-loader">
      <div class="loader">
        <div v-if="loaderTextDynamic.length > 0" class="loader-text">
          {{ loaderTextDynamic }}
        </div>
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["loaderText"],
  watch: {
    loaderText() {
      this.loaderTextDynamic = this.loaderText;
    },
  },
  data() {
    return {
      loaderTextDynamic: "",
    };
  },
};
</script>
<style scoped>
.loader-text {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  background-color: #0000002e;
  margin: 0 auto;
  width: 35%;
  padding: 5px;
}
.page-loader {
  background-color: rgb(0 0 0 / 70%);
  height: 100%;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 999999;
  text-align: center;
}
.loader {
  top: 50%;
  margin: 0 auto;
  width: 100%;
  position: fixed;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.fade-enter-active {
  transition: opacity 0.2s linear;
}
.fade-leave-active {
  transition: opacity 0.3s linear;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media only screen and (max-width: 767px) {
  .loader {
    transform: translateY(-50%);
  }
  .loader-text {
    font-size: 16px;
    width: 98%;
  }
  .lds-ellipsis[data-v-40df972a] {
    height: 50px;
  }
}
</style>
